/** Copyright (c) 2021 T.Rowe Price. All rights reserved. */

import './PRRDisclosure.scss';

import { bool } from 'prop-types';
import React from 'react';

import DisclosureModal from 'components/shared/Disclosure/DisclosureModal';
import Content from 'services/Content';

const PRRDisclosure = () => {
  return (
    <div className="prr-disclosure">
      <DisclosureModal
        className="restricted-height-modal"
        content={Content.prrPerformanceDisclosure}
        hideLinkContent
      />
    </div>
  );
};

PRRDisclosure.propTypes = {
  showAdviceDisclosure: bool
};

export default PRRDisclosure;
